<div
  class="tt-object-attr-filter"
  [class.opacity-60]="disabled"
  [class.tt-object-attr-filter--loading]="loading"
  role="group"
  aria-label="Filtry HP a Dig."
>
  <button
    #hpTrigger
    type="button"
    class="tt-filter-icon-btn tt-object-attr-filter__icon"
    [class.tt-filter-icon-btn--active]="isActive(hp) || openDim === 'hasHp'"
    [disabled]="disabled"
    [attr.aria-busy]="loading"
    [attr.aria-label]="dimAria('hasHp')"
    [attr.aria-pressed]="isActive(hp)"
    [attr.aria-expanded]="openDim === 'hasHp'"
    [title]="dimTitle('hasHp')"
    (mousedown)="$event.stopPropagation()"
    (click)="togglePanel('hasHp', $event)"
  >
    <span class="tt-object-attr-filter__label">HP</span>
    <span *ngIf="loading" class="tt-object-attr-filter__spinner" aria-hidden="true"></span>
    <span *ngIf="!loading && hpBadge() as badge" class="tt-object-attr-filter__mode" aria-hidden="true">{{ badge }}</span>
    <span *ngIf="isActive(hp)" class="tt-filter-icon-btn__badge" aria-hidden="true"></span>
  </button>

  <button
    #dcTrigger
    type="button"
    class="tt-filter-icon-btn tt-object-attr-filter__icon"
    [class.tt-filter-icon-btn--active]="isActive(digCesta) || openDim === 'digitalniCesta'"
    [disabled]="disabled"
    [attr.aria-busy]="loading"
    [attr.aria-label]="dimAria('digitalniCesta')"
    [attr.aria-pressed]="isActive(digCesta)"
    [attr.aria-expanded]="openDim === 'digitalniCesta'"
    [title]="dimTitle('digitalniCesta')"
    (mousedown)="$event.stopPropagation()"
    (click)="togglePanel('digitalniCesta', $event)"
  >
    <span class="tt-object-attr-filter__label">Dig.</span>
    <span *ngIf="loading" class="tt-object-attr-filter__spinner" aria-hidden="true"></span>
    <span *ngIf="!loading && digBadge() as badge" class="tt-object-attr-filter__mode" aria-hidden="true">{{ badge }}</span>
    <span *ngIf="isActive(digCesta)" class="tt-filter-icon-btn__badge" aria-hidden="true"></span>
  </button>

  <div
    #panelEl
    *ngIf="openDim"
    class="tt-filter-overlay-panel tt-object-attr-filter__panel fixed"
    [ngStyle]="panelStyle"
    role="dialog"
    [attr.aria-label]="'Filtr: ' + openLabel"
    (mousedown)="$event.stopPropagation()"
  >
    <div class="tt-filter-overlay-panel__title">{{ openLabel }}</div>
    <input
      type="text"
      class="input tt-filter-control tt-object-attr-filter__expr"
      [attr.aria-label]="'Výraz ' + openLabel"
      placeholder=">3"
      [value]="draftExpr"
      (input)="onDraftExprInput($any($event.target).value)"
      (keydown)="onDraftKeydown($event)"
      inputmode="text"
      autocomplete="off"
      spellcheck="false"
    />
    <div class="tt-object-attr-filter__panel-hint">např. &gt;3, &lt;10, =0</div>
    <div class="tt-object-attr-filter__panel-actions">
      <button
        type="button"
        class="tt-object-attr-filter__apply"
        [disabled]="loading"
        (click)="applyDraft()"
      >
        {{ loading ? 'Načítám…' : 'Použít' }}
      </button>
      <button
        *ngIf="openDim === 'hasHp' ? isActive(hp) : isActive(digCesta)"
        type="button"
        class="tt-object-attr-filter__clear"
        (click)="clearDraft($event)"
      >
        Zrušit filtr
      </button>
    </div>
  </div>
</div>
